import Vue from "vue";
import {
  Model,
  Prop,
  Component,
  Mixins,
  Watch,
  Inject
} from "vue-property-decorator";
import { Validator } from "vee-validate";
import { MethodService } from "@/utils/serviceModel";

@Component
export default class InputBase extends Vue {
  [key: string]: any;
  @Model("input")
  protected returnValue!: any;

  @Prop({ default: () => {} })
  protected model: IndexObject | any;

  @Prop({ default: () => {} })
  protected prop!: IProp;

  @Prop()
  protected readonly!: boolean;

  private validator: Validator = new Validator();
  private unique: any = null;

  protected error: any = "";

  protected get value() {
    if (this.model) {
      return this.model[this.prop.value];
    }
    return this.returnValue;
  }

  protected set value(val) {
    let value = val;
    if (this.rules) {
      this.validator
        .verify(value, this.rules, { name: this.prop.text })
        .then(res => {
          if (!res.valid) {
            this.error = res.errors[0];
          } else {
            this.error = "";
          }
        });
    }
    this.uniqueValidate(value);

    if (this.model) {
      this.$set(this.model, this.prop.value, value);
    } else {
      this.$emit("input", value);
    }
  }

  private get rules() {
    if (this.prop) {
      if (this.prop.rules) {
        return this.prop.rules;
      }
    }
    return null;
  }

  @Watch("rules")
  private observeRules() {}

  mounted() {}

  created() {
    this.unique = value => true;
    this.validator.extend("unique", this.unique);
  }

  // private loadUnique() {
  //   if (this.rules && this.prop && this.model) {
  //     if (this.rules.indexOf("unique") >= 0) {
  //       this.unique = this.createUniqueValidate();

  //     }
  //   }
  // }

  // private createUniqueValidate() {
  //   let unique = {
  //     getMessage: field => field + "必须唯一！",
  //     validate: value => {
  //       return this.invokeUniqueService(value).then(val => val);
  //     }
  //   };
  //   return unique;
  // }

  private uniqueValidate(value) {
    if (value && this.rules && this.prop && this.model) {
      if (this.rules.indexOf("unique") >= 0) {
        this.invokeUniqueService(value);
      }
    }
  }

  private async invokeUniqueService(value) {
    if (this.rules && this.prop && this.model) {
      if (this.rules.indexOf("unique") >= 0) {
        let args = {
          ["value"]: value,
          ["col_id"]: this.prop.Id,
          column: this.prop.value,
          model_id: this.model.Id
        };
        try {
          let res = await this.uniqueService.invokeAsyn(args);
          if (res.data.isSuccess) {
            let error = "";
            if (!res.data.data) {
              error = this.prop.text + "必须唯一！";
              this.error = error;
            } else {
              if (this.error === error) {
                this.error = "";
              }
            }

            return res.data.data;
          } else {
            this.error = "调用验证服务失败!:" + res.data.error;
          }
        } catch (error) {
          this.error = "调用验证服务失败:" + error;
        }
      }
    }
  }

  private uniqueService = new MethodService(
    "plat.common",
    "CommonService",
    "unique"
  );
}
